<template>
  <div
    :class="[
      'bg-white dark:bg-neutral-800 rounded-xl shadow-soft border border-neutral-200 dark:border-neutral-700 p-6',
      fill ? 'h-full flex flex-col' : '',
    ]"
  >
    <div class="flex items-center justify-between mb-4 gap-3">
      <div class="min-w-0">
        <h2 class="text-lg font-semibold text-neutral-900 dark:text-neutral-100">{{ title }}</h2>
        <p v-if="subtitle" class="text-xs text-neutral-500 dark:text-neutral-400 mt-0.5">{{ subtitle }}</p>
      </div>
      <slot name="actions"></slot>
    </div>

    <!-- Loading: a skeleton in the chart's footprint (same language as the KPI cards) -->
    <div v-if="loading" :class="resolvedBodyClass" aria-busy="true" aria-label="Loading chart">
      <div class="h-full w-full rounded-lg bg-neutral-100 dark:bg-neutral-700/50 animate-pulse"></div>
    </div>

    <!-- Empty -->
    <div
      v-else-if="isEmpty"
      class="flex items-center justify-center text-neutral-400 dark:text-neutral-500"
      :class="resolvedBodyClass"
    >
      <div class="text-center">
        <span class="material-icons text-4xl" aria-hidden="true">{{ emptyIcon }}</span>
        <p class="text-sm mt-2">{{ emptyText }}</p>
      </div>
    </div>

    <!-- Content -->
    <div
      v-else
      :class="resolvedBodyClass"
      :role="ariaLabel ? 'img' : null"
      :aria-label="ariaLabel || null"
    >
      <slot></slot>
    </div>

    <div v-if="$slots.footer" class="mt-3 text-xs text-neutral-500 dark:text-neutral-400">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'ChartCard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    isEmpty: { type: Boolean, default: false },
    emptyIcon: { type: String, default: 'bar_chart' },
    emptyText: { type: String, default: 'No data available' },
    bodyClass: { type: String, default: 'h-64' },
    // fill: stretch to the grid row's height (body grows, min 16rem) so a chart
    // beside a taller list card lines up instead of leaving a ragged row.
    fill: { type: Boolean, default: false },
    // Text alternative for the slotted canvas chart (chart.js renders no
    // fallback content); when set the body becomes role="img".
    ariaLabel: { type: String, default: '' },
  },
  setup(props) {
    const resolvedBodyClass = computed(() => (props.fill ? 'flex-1 min-h-64 relative' : props.bodyClass))
    return { resolvedBodyClass }
  },
}
</script>
